import React from "react";
import Header from "../components/Header";
import Footer from "../components/Footer";
import Details from "../components/profile/Details";

function ProfilePage() {
  return (
    <>
      <Header />
      <Details />
      <Footer />
    </>
  );
}

export default ProfilePage;
